import styled from 'styled-components';

// Bespoke legend beside the plot, mirroring the app's standard charts
// (annual-emissions, emissions-reductions), which disable Highcharts' built-in
// legend and render their own. Fixed-width column to the chart's right.
const LegendContainer = styled.div`
  width: 166px;
  flex: 0 0 166px;
  margin-left: 16px;
`;

export { LegendContainer };
